export default "__VITE_ASSET__BqSQ7p3f__"